var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"designer",staticStyle:{"position":"absolute","left":"0","right":"0","top":"0","bottom":"0","height":"800px"},attrs:{"data-bind":"dxReportDesigner: $data"}})}
var staticRenderFns = []

export { render, staticRenderFns }